import React, { useState, useEffect } from 'react';
import { Typography, Box, Chip } from '@mui/joy';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';

export default function Profile() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/');
        return;
      }

      // Check if id is undefined or invalid
      if (!id || id === 'undefined') {
        setError('Invalid user ID');
        return;
      }

      try {
        const response = await axios.get(`http://localhost:5000/api/profile/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setProfile(response.data);
      } catch (err) {
        setError(err.response?.data.message || 'Error fetching profile');
      }
    };
    fetchProfile();
  }, [id, navigate]);

  if (error)
    return (
      <Typography color="danger" sx={{ textAlign: 'center', mt: 12 }}>
        {error}
      </Typography>
    );

  if (!profile)
    return (
      <Typography sx={{ textAlign: 'center', mt: 12 }}>
        Loading...
      </Typography>
    );

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', p: 2, mt: 12 }}>
      <Box sx={{ textAlign: "center", mb: 3 }}>
        {profile.image ? (
          <img
            src={`http://localhost:5000${profile.image}`}
            
            alt="Profile"
            style={{
              width: "120px",
              height: "120px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid #0070ba",
            }}
          />
        ) : (
          <Typography>No profile picture</Typography>
        )}
      </Box>

      <Typography level="h4">{profile.name}</Typography>
      <Typography>Country: {profile.country}</Typography>
      <Typography>
        Skills:{" "}
        {profile.skillTags?.length ? (
          profile.skillTags.map((tag) => (
            <Chip key={tag} sx={{ m: 0.5 }}>
              {tag}
            </Chip>
          ))
        ) : (
          "None"
        )}
      </Typography>
      <Typography>Status: {profile.verificationStatus || "Pending"}</Typography>
      <Typography>Role: {profile.role || "User"}</Typography>
    </Box>
  );
}